import type { RescheduleSuggestionDTO } from 'src/types/dto/reschedule-suggestion.dto';

import { fStartDateShortLabel } from 'src/utils/format-time';

import type { InspectorAvailabilityResult } from './types';

export const mapRescheduleSuggestionToResult = (
  item: RescheduleSuggestionDTO,
  isDeskService = false
): InspectorAvailabilityResult => {
  const travelDistance = item.changes.reduce(
    (acc, change) =>
      acc +
      change.newAppointment.reduce(
        (appointmentAcc, appointment) =>
          appointmentAcc +
          +(appointment.travelToSiteDistance ?? 0) +
          +(appointment.travelFromSiteDistance ?? 0),
        0
      ),
    0
  );

  const earliestAppointment = item.changes[0]?.newAppointment[0];

  return {
    id: item.solutionId,
    name: item.inspector.name,
    subtitle: item.inspector.address,
    type: item.inspector.type,
    competencies:
      item.inspector.authorizations
        ?.map((authorization) => authorization.competency?.name ?? authorization.name)
        .filter((name): name is string => Boolean(name)) ?? [],
    travelLabel: isDeskService ? '0.0km' : `${travelDistance.toFixed(1)}km`,
    businessUnit:
      item.inspector.businessUnit?.name ?? item.inspector.user?.businessUnits?.[0]?.name,
    dateLabel: earliestAppointment?.from
      ? (fStartDateShortLabel(earliestAppointment.from) ?? '-')
      : '-',
    changesCount: item.changes.length,
  };
};
